import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { ProductionRunDevPaperwork } from '../components/ProductionRunDevPaperwork';
import { TerreHautePaperwork } from '../components/TerreHautePaperwork';
import { ProductionOrderPaperwork } from '../components/ProductionOrderPaperwork';
import { ProductionSinglePaperwork } from '../components/ProductionSinglePaperwork';
import { RollFormingPaperwork } from '../components/RollFormingPaperwork';
import { ShortDoorReport } from '../components/ShortDoorReport';
import { ServiceCenterStickersReport } from '../components/ServiceCenterStickersReport';
import { WindloadChecklistReport } from '../components/WindloadChecklistReport';
import { OrderErrorsReport } from '../components/OrderErrorsReport';
import { CustomAccentReport } from '../components/CustomAccentReport';
import { FullviewExport } from '../components/FullviewExport';
import { EngineeringReviewByDateExport } from '../components/EngineeringReviewByDateExport';

export class ProductionReportsScene extends React.Component {

    public render() {
        return <PageContent pageName={'awef'}>
            <PageBody>
                <div className="row">
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionTerreHautePaperwork
                    ]}>
                        <div className="col-md-4"><TerreHautePaperwork /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionProductionPaperworkDevelopment
                    ]}>
                        <div className="col-md-4"><ProductionRunDevPaperwork /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionProductionPaperworkOrders
                    ]}>
                        <div className="col-md-4"><ProductionOrderPaperwork /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionProductionPaperworkSingle
                    ]}>
                        <div className="col-md-4"><ProductionSinglePaperwork /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionRollFormingPaperwork
                    ]}>
                        <div className="col-md-4"><RollFormingPaperwork /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionShortDoor
                    ]}>
                        <div className="col-md-4"><ShortDoorReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionCustomAccent
                    ]}>
                        <div className="col-md-4"><CustomAccentReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionStickers
                    ]}>

                        <div className="col-md-4"><ServiceCenterStickersReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionWindloadChecklist
                    ]}>
                        <div className="col-md-4"><WindloadChecklistReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionOrderErrors
                    ]}>
                        <div className="col-md-4"><OrderErrorsReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionFullviewExport
                    ]}>
                        <div className="col-md-4"><FullviewExport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsProductionEngineeringReviewByCutoffDate
                    ]}>
                        <div className="col-md-4"><EngineeringReviewByDateExport /></div>
                    </HasPermission>
                </div>
            </PageBody>
        </PageContent>;
    }
}
